import { useFormikContext } from 'formik';
import { useGetMarkets } from 'hooks/useGetMarkets';
import { IFormValues } from '../types';
import { DealMapSource, getDealMapSource } from './getDealMapSource';

export const useDealLocationIntent = (): DealMapSource => {
    const { values } = useFormikContext<IFormValues>();
    const { data: markets } = useGetMarkets();

    const selectedMarket = markets?.find(market => market.correlationId === values.marketId);
    
    return getDealMapSource(values, selectedMarket);
};
